import { Amplify } from 'aws-amplify';
import awsconfig from './src/aws-exports'; // adjust path if needed
import '@aws-amplify/auth';
import "./src/assets/css/styles.css"

Amplify.configure(awsconfig);
